import { render, staticRenderFns } from "./CollectionItemGuestFlow.vue?vue&type=template&id=c71947c6&scoped=true&v-on-clickaway=cancel&"
import script from "./CollectionItemGuestFlow.vue?vue&type=script&lang=ts&"
export * from "./CollectionItemGuestFlow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71947c6",
  null
  
)

export default component.exports